const { h, render, Component } = require('preact');

class DealImage extends Component {
  constructor(props) {
    super(props);
    this.goToDealPage = this.goToDealPage.bind(this);
  }

  goToDealPage() {
    if (this.props.dealDetails.id){
      window.open(`/deals/${this.props.dealDetails.id}`, "_blank")
    }
  }

  render() {
    if (this.props.dealDetails && this.props.dealDetails.largeImageUrl){
      return (
        <img data-bhw="web2018_deal_image" class="deal-image" src={this.props.dealDetails.largeImageUrl} onClick={this.goToDealPage} alt={"Deal Image"+ this.props.dealDetails.title}/>
      );
    }
    return null;
  }
}
module.exports = DealImage
